import React, { useState, useEffect } from 'react';

import Segment from '../../../components/Segment';
import { Status as StatusInterface, DateRange } from '../../../types';
import { fetchGlanceData, returnSalesData } from './../helpers';

interface Props {
  dateRange: DateRange;
  currency: string;
  setFetching: (fetching: boolean) => void;
}

const SalesSegment = ({ dateRange, currency, setFetching }: Props): React.ReactElement => {
  const [glanceSalesData, setGlanceSalesData] = useState<any>();
  const [status, setStatus] = useState<StatusInterface[]>([]);

  const fetchGlanceSales = async (params: any, path: string) => {
    setFetching(true);

    (async () => {
      try {
        const data = await fetchGlanceData(path, params);
        setGlanceSalesData(data && returnSalesData(data));
        setFetching(false);
      } catch (error: any) {
        setStatus([...status, { state: 'error', message: error }]);
        setFetching(false);
      }
    })();
  };

  useEffect(() => {
    //reset
    resetSalesData();

    const params = {
      startDate: dateRange.startDate,
      endDate: dateRange.endDate
    };
    const path = 'atglance/sales/summary';

    fetchGlanceSales(params, path);
  }, []);

  const resetSalesData = () => {
    setGlanceSalesData(null);
  };

  return (
    <>
      {glanceSalesData && (
        <Segment
          title={glanceSalesData.title.toUpperCase()}
          variant={'glanceView'}
          totalValue={glanceSalesData.currentValue}
          unit={glanceSalesData.currentValueType === 'percentage' ? '%' : ''}
          currency={currency}
          YoY={glanceSalesData.yoyPercentageChange}
          MoM={glanceSalesData.momPercentageChange}
          target={glanceSalesData.planPercentageChange}
          displayData={['YoY', 'MoM', 'target']}
        />
      )}
    </>
  );
};

export default SalesSegment;
